export function parseSkillTags(value: string): string[] {
  const seen = new Set<string>()
  const parsed: string[] = []

  for (const raw of value.split(',')) {
    const tag = raw.trim().replace(/\s+/g, ' ')
    const key = tag.toLowerCase()
    if (!tag || seen.has(key)) continue
    seen.add(key)
    parsed.push(tag)
  }

  return parsed
}
